<template>
  <v-dialog
      v-model="isActive" persistent
      width="500" overlay-color=""
  >
    <v-card class="d-flex justify-center align-center flex-column pa-10">
      <v-card-text class="text-center text-h6 font-weight-bold black--text">
        {{ message }}
      </v-card-text>
      <v-card-actions>
        <v-btn class="button save px-10" outlined @click="callBack(true)">확인</v-btn>
        <v-btn class="button save px-10" outlined @click="callBack(false)">취소</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default  {
  name: "Confirm",
  props: ["isActive"],
  computed: {
    ...mapGetters("alert", {
      message: "message",
      successCallback: "successCallback",
      failCallback: "failCallback"
    })
  },
  methods: {
    ...mapActions("alert", ["initData"]),
    callBack(isCallback) {
      isCallback
        ? this.successCallback()
        : this.failCallback()
      this.initData();
    }
  }
}
</script>